import { makeActions } from 'redux/crudCreator/actions';

export const MODEL_NAME = 'regions';
export const regionsActions = makeActions(MODEL_NAME);

export const getAllRegions = regionsActions.getAll;
export const editRegions = regionsActions.edit;
export const createRegions = regionsActions.create;
export const getByIdRegions = regionsActions.getDataById;
